// @TODO WMG1-663 - Implement benchmarks component
export function Benchmarks() {
  return <div data-testid="benchmarks" />;
}

Benchmarks.displayName = 'Benchmarks';
